import React, { useEffect, useRef, useState } from 'react';
import { PackagesScreen } from './packages/ui/screens/PackagesScreen';
export default function PackagesConfiguration() {

    return (
        <div>
            <PackagesScreen></PackagesScreen>
        </div>
    );
}